<template src="./Projects.component.html"></template>
<style type="text/css" src="./Projects.component.css"></style>
<!-- <style type="text/css" src="./slick.css"></style> -->

<script>
import Slick from 'vue-slick';
export default {
  name: 'Projects',
  components: {
    Slick
  },
  data () {
    return {
      slickOptions: {
        slidesToShow: 1,
        vertical: true,
        touchMove: true,
        swipeToSlide: true,
        slidesToScroll: 1,
        pauseOnHover: true,
        pauseOnFocus: true,
        infinite: true,
        draggable: false,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        centerPadding: '0px'
          // Any other options that can be got from plugin documentation
      },
      mobileSlickOptions: {
        slidesToShow: 1,
        vertical: true,
        touchMove: true,
        swipeToSlide: true,
        slidesToScroll: 1,
        pauseOnHover: true,
        pauseOnFocus: true,
        infinite: true,
        draggable: false,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        centerPadding: '0px'
          // Any other options that can be got from plugin documentation
      }
    }
  },
  methods: {
    next() {
        this.$refs.slickProjects.next();
    },

    prev() {
        this.$refs.slickProjects.prev();
    },
    mobilePrev () {
        this.$refs.mobileslickProjects.prev();
    },
    mobileNext () {
        this.$refs.mobileslickProjects.next();
    },
    reInit() {
        // Helpful if you have to deal with v-for to update dynamic lists
        this.$nextTick(() => {
            this.$refs.slickProjects.reSlick();
        });
        this.$nextTick(() => {
            this.$refs.mobileslickProjects.reSlick();
        });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/Projects.component.vue